import type { ReactNode } from "react";
import { Page } from "@/components/core/Page";

/**
 * @deprecated Use <Page width="…"> directly. Kept as a backward-compatible
 * alias (width="default") so existing pages keep working during migration.
 */
export const PageWrapper = ({
  children,
  outsideChildren,
  bottomChildren,
  className,
  containerClassName,
}: {
  children?: ReactNode;
  outsideChildren?: ReactNode;
  bottomChildren?: ReactNode;
  className?: string;
  containerClassName?: string;
}) => (
  <Page
    width="default"
    outsideChildren={outsideChildren}
    bottomChildren={bottomChildren}
    className={className}
    containerClassName={containerClassName}
  >
    {children}
  </Page>
);
